import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';
import { connect } from 'react-redux';
import { deleteExperience } from '../../actions/profile';

const Experience = ({ experience, deleteExperience }) => {
  const experiences = experience.map((exp) => (
    <div className="credential" key={exp._id}>
      <div className="card-body p-1 m-3 rounded-lg shadow-sm">
        <h6 className="d-inline ml-1">{exp.title}</h6>
        <a
          href="#!"
          onClick={() => deleteExperience(exp._id)}
          className="text-secondary float-right delete"
        >
          <i className="fas fa-trash-alt"></i>
        </a>
        <span className="text-muted location"> &#8226; {exp.location}</span>

        <p className="ml-2 company">{exp.company}</p>

        <p className="mb-0 ml-2 text-muted years">
          {' '}
          <Moment format="MMM YYYY">{moment.utc(exp.from)}</Moment> -{' '}
          {exp.to === null ? (
            ' Now'
          ) : (
            <Moment format="MMM YYYY">{moment.utc(exp.to)}</Moment>
          )}
        </p>
      </div>
    </div>
  ));

  return (
    <Fragment>
      <div className="card rounded-0 my-3 shadow-sm">
        <div className="exp shadow-sm card-body pb-3">
          <div className="mb-1">
            <h5 className="m-0 d-inline">Work Experience</h5>
            <span className="text-muted">
              {' '}
              &#8226; Internships and Companies
            </span>
          </div>

          <Link to="/add-experience" className="add-stuff">
            <i className="fas fa-plus-circle"></i> Add experience
          </Link>
        </div>
        <div className="credentials">{experiences}</div>
      </div>
    </Fragment>
  );
};

Experience.propTypes = {
  experience: PropTypes.array.isRequired,
  deleteExperience: PropTypes.func.isRequired
};

export default connect(null, { deleteExperience })(Experience);
